<!-- ─────────────────────────────────────────────────────────────────────── -->
<!-- Inbox Sidebar                                                         -->
<!-- Left-hand navigation: folders, accounts, categories, statuses, users  -->
<!-- ─────────────────────────────────────────────────────────────────────── -->
<div class="inbox-sidebar" [class.expanded]="isExpanded" [class.collapsed]="!isExpanded">

    <!-- ─── Top Actions (compose + toggle) ─────────────────────────────── -->
    <div class="inbox-sidebar__actions">
        <ui-button
            type="primary"
            icon="compose"
            [label]="isExpanded ? ('smart_inbox.inbox_view.sidebar_nav.compose' | translate) : ''"
            [fullWidth]="true"
            (click)="openCompose()">
        </ui-button>
        <ui-button
            type="transparent"
            icon="toggel_sidebar"
            [style.marginLeft]="'auto'"
            (click)="toggleExpanded()">
        </ui-button>
    </div>

    <!-- ─── Scrollable Content ─────────────────────────────────────────── -->
    <div class="inbox-sidebar__scroll">

        <!-- ─── System Folders ─────────────────────────────────────────── -->
        <div class="inbox-sidebar__folders">
            <span
                class="inbox-sidebar__nav-btn"
                [class.selected]="activeFolder === folder.type"
                *ngFor="let folder of foldersWithKpis"
                (click)="selectFolder(folder.type)">
                <ui-icon [name]="folder.icon"></ui-icon>
                <span class="inbox-sidebar__folder-label" *ngIf="isExpanded">
                    <span class="inbox-sidebar__folder-label-text">{{ folder.label | translate }}</span>
                    <span class="inbox-sidebar__folder-label-counter" *ngIf="getFolderCounter(folder) > 0">
                        {{ getFolderCounter(folder) }}
                    </span>
                </span>
            </span>
        </div>

        <!-- ─── Accounts Section ───────────────────────────────────────── -->
        <div class="inbox-sidebar__section" *ngIf="isExpanded">
            <div class="inbox-sidebar__section-header inbox-sidebar__nav-btn"
                 (click)="sectionCollapsed['accounts'] = !sectionCollapsed['accounts']">
                <ui-icon
                    [name]="sectionCollapsed['accounts'] ? 'ChevronRight' : 'ChevronDown'"
                    size="small">
                </ui-icon>
                <span>{{ 'smart_inbox.inbox_view.sidebar_nav.accounts' | translate }}</span>
            </div>

            <div class="section-content" *ngIf="!sectionCollapsed['accounts']">
                <span class="inbox-sidebar__nav-btn inbox-sidebar__account-item">
                    <mat-checkbox [checked]="isAllAccountsSelected()" (change)="selectAllAccounts()" (click)="$event.stopPropagation()">
                    </mat-checkbox>
                    <span class="inbox-sidebar__account-name">
                        <ui-icon name="Mail"></ui-icon>
                        {{ 'smart_inbox.inbox_view.sidebar_nav.all' | translate }}
                    </span>
                </span>
                <ng-container *ngFor="let account of accounts">
                    <span class="inbox-sidebar__nav-btn inbox-sidebar__account-item">
                        <mat-checkbox
                            [checked]="isAccountActive(account)"
                            (change)="toggleAccount(account)"
                            (click)="$event.stopPropagation()">
                        </mat-checkbox>

                        <span class="inbox-sidebar__account-name"
                              [matTooltip]="accountTooltips[account.id]"
                              matTooltipClass="inbox-account-tooltip">

                            <ng-container *ngIf="account.mailbox_type !== 'shared'">
                                <span class="inbox-sidebar__account-name-content">
                                    <span class="inbox-sidebar__account-name-text">{{ account.name }}</span>
                                    <span class="inbox-sidebar__account-type">
                                        <!-- Connection health, and the affordance for it:
                                             the single indicator for this mailbox's
                                             connection. Clicking a mailbox that needs
                                             attention opens the Status tab, where
                                             Re-connect lives.
                                             No tooltip of its own — the status is the
                                             second line of the row's tooltip, so
                                             hovering never opens two at once. -->
                                        <span [class]="'inbox-sidebar__account-status is-' + connectionStatusTone(account)"
                                              [class.is-actionable]="isConnectionDotActionable(account)"
                                              [attr.role]="isConnectionDotActionable(account) ? 'button' : null"
                                              [attr.tabindex]="isConnectionDotActionable(account) ? 0 : null"
                                              [attr.aria-label]="isConnectionDotActionable(account) ? (connectionAlertTooltip(account) | translate) : null"
                                              [attr.aria-hidden]="isConnectionDotActionable(account) ? null : 'true'"
                                              (click)="onConnectionAlertClick(account, $event)"
                                              (keydown.enter)="onConnectionAlertClick(account, $event)"
                                              (keydown.space)="onConnectionAlertClick(account, $event)"></span>
                                        <ui-icon name="Mail" size="small"></ui-icon>
                                        {{ (account.mailbox_type === 'team' ? 'smart_inbox.inbox_view.sidebar_nav.team' : 'smart_inbox.inbox_view.sidebar_nav.personal') | translate }}
                                    </span>
                                </span>
                            </ng-container>

                            <ng-container *ngIf="account.mailbox_type === 'shared'">
                                <ui-icon name="Mail"></ui-icon>
                                {{ 'smart_inbox.inbox_view.sidebar_nav.shared_with_me' | translate }}
                            </ng-container>
                        </span>

                        <span class="inbox-sidebar__account-actions">
                            <ui-icon
                                *ngIf="account.mailbox_type !== 'shared' && isOwnerOfAccount(account)"
                                class="inbox-sidebar__settings-icon"
                                [style.cursor]="'pointer'"
                                name="Settings"
                                size="medium"
                                (click)="openAccountSettings(account); $event.stopPropagation()">
                            </ui-icon>
                        </span>
                    </span>
                </ng-container>

                <ui-button
                    type="transparent"
                    icon="add"
                    iconSize="medium"
                    [label]="'smart_inbox.inbox_view.sidebar_nav.connect_account' | translate"
                    (click)="onAddNewAccount()">
                </ui-button>
            </div>
        </div>

    </div><!-- /inbox-sidebar__scroll -->
</div>
